// export const api = "https://63899fdc4eccb986e895a926.mockapi.io"
export const api = "https://movie-app-server-two.vercel.app"
